import React, { useState } from 'react';
import { MessageCircle, X, Bot } from 'lucide-react'; // Import Bot icon
import CandidateChatbot from '../chatbot/CandidateChatbot';
import './ChatbotWidget.css';

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [initialBotMessageDisplayed, setInitialBotMessageDisplayed] = useState(false);

  // Function to toggle the chatbot and manage initial message display
  const toggleChatbot = () => {
    setIsOpen(!isOpen);
    if (!isOpen) { // If opening the chatbot
      setInitialBotMessageDisplayed(true);
    }
  };

  return (
    <>
      {/* Floating Button with Tooltip */}
      <div
        className="chatbot-widget-container"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="tooltip">
            Chat Assistant
          </div>
        )}

        {/* Chat Button */}
        <div
          className="chat-button"
          onClick={toggleChatbot}
        >
          {isOpen ? <X size={28} /> : <Bot size={28} />} {/* Changed to Bot icon when closed */}
        </div>

        {/* Initial "Hi" bubble if not open and not yet displayed */}
        {!isOpen && !initialBotMessageDisplayed && (
          <div className="initial-greeting-bubble">
            <Bot size={18} className="mr-1" /> Hi! 👋
          </div>
        )}
      </div>

      {/* Chat Window */}
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <span className="font-semibold">BGV Chat Assistant 🤖</span>
            <button onClick={() => setIsOpen(false)} className="close-btn">
              ✕
            </button>
          </div>
          <div className="chat-content">
            <CandidateChatbot />
          </div>
        </div>
      )}
    </>
  );
};

export default ChatbotWidget;